import { KuposModal, KuposModalWithButtons } from '../../../common';
import React, { Component, useState } from 'react';

import CommonService from '../../../../services/commonService';
import PropTypes from 'prop-types';

const getSeatIcon = (seat, petSeats) => {
  if (petSeats && petSeats[seat.number]) {
    if (!seat.isGangWay && seat.isReservable && seat.number && !seat.isSelected) {
      return 'icon-pet-seat_available';
    } else if (!seat.isGangWay && seat.isReservable && seat.isSelected) {
      return 'icon-pet-seat_selected';
    } else if (!seat.isGangWay && !seat.isReservable) {
      return 'icon-pet-seat_occupied';
    }
  }
  if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.number &&
    !seat.isSelected &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase() == 'PREMIUM'
  ) {
    return 'icon-vip-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase() == 'PREMIUM'
  ) {
    return 'icon-vip-seat_selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.type.toUpperCase() == 'PREMIUM') {
    return 'icon-vip-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('SALON CAMA') > -1
  ) {
    return 'icon-salon-cama-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('SALON CAMA') > -1
  ) {
    return 'icon-salon-cama-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('SALON CAMA') > -1
  ) {
    return 'icon-salon-cama-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_occupied';
  } else if (seat.number == 'DR_IMG') {
    return 'icon-steering';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase() == 'CAMA PREMIUM'
  ) {
    return 'icon-vip-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase() == 'CAMA PREMIUM'
  ) {
    return 'icon-vip-seat_selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.type.toUpperCase() == 'CAMA PREMIUM') {
    return 'icon-vip-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('BIO BIO SUPERIOR') > -1
  ) {
    return 'icon-salon-cama-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('BIO BIO SUPERIOR') > -1
  ) {
    return 'icon-salon-cama-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('BIO BIO SUPERIOR') > -1
  ) {
    return 'icon-salon-cama-seat_occupied';
  } else if (!seat.isGangWay && seat.isReservable && !seat.isSelected) {
    return 'icon-salon-cama-seat_available';
  } else if (!seat.isGangWay && seat.isReservable && seat.isSelected) {
    return 'icon-salon-cama-seat_selected';
  } else if (!seat.isGangWay && !seat.isReservable) {
    return 'icon-salon-cama-seat_occupied';
  }
};

const getSeatTypeName = seat => {
  if (!seat.isGangWay && seat.isReservable && seat.number && !seat.isSelected && seat.number) {
    return 'available';
  } else if (!seat.isGangWay && seat.isReservable && seat.isSelected && seat.number) {
    return 'selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.number) {
    return 'occupied';
  }
};

function CoachLayout(props) {
  let seatMouseoverDivEl = [];
  const [petseatModal, setPetseatModal] = useState({});

  const seatRow = () => {
    let rows = props.coachLayout.map((row, i) => <ul key={i + Math.random()}>{seatCol(row)}</ul>);
    return rows;
  };

  const seatCol = row => {
    let cols = row.map((seat, i) => {
      // console.log('Seat is ------------', seat);
      return !(
        seat.isGangWay ||
        seat.isBreak ||
        (seat.number && (seat.number.indexOf('GY') > -1 || seat.number.indexOf('gy') > -1))
      ) && seat.object.floor_no === props.selectedFloor ? (
        seatItem(seat, i)
      ) : (
        <li key={i + Math.random()} className="gw">
          {' '}
        </li>
      );
    });
    return cols;
  };
  const getSeatName = rawSeat => {
    console.log('Raw seat internal moore-----------'.rawSeat);
    switch (rawSeat) {
      case 'SALON CAMA':
        return 'Salón Cama';
        break;
      case 'MACOTA A BORDO':
        return 'Macota a Bordo';
      case 'CLASICO':
        return 'Clásico';
        break;
      case 'Clasico':
        return 'Clásico';
        break;
      case 'Salon Sin Vent':
        return 'Salón Sin Vent';
        break;
      case 'SALON SIN VENT':
        return 'Salón Sin Vent';
        break;
      case 'Salon Preferente':
        return 'Salón Preferente';
        break;
      case 'SALON PREFERENTE':
        return 'Salón Preferente';
        break;
      case 'SALON':
        return 'Salón ';
        break;
      case 'Salon':
        return 'Salón ';
        break;
      case "SALON CAMA P":
        return "Salón Cama P";
      case "SALON CAMA IND":
        return "Salón Cama IND";
      default:
        return CommonService.capitalize(rawSeat);
        break;
    }
  };

  const isPetSeatPair = seat => {
    for (let p in props.petSeats) {
      let sNo = props.petSeats[p].find(it => it == seat.number);
      if (sNo) {
        let seats = [];
        for (let row of props.coachLayout) {
          if (!seats[0]) seats[0] = row.find(it => it.number == props.petSeats[p][0]);
          if (!seats[1]) seats[1] = row.find(it => it.number == props.petSeats[p][1]);
        }
        return seats;
      }
    }
    return null;
  };

  const seatItem = (seat, i) => {
    return seat.number ? (
      <li
        rowSpan={seat.rowSpan}
        colSpan={seat.colSpan}
        className={getSeatTypeName(seat) + ' ' + getSeatIcon(seat, props.petSeats).split('_')[0]}
        key={i + Math.random()}
        onClick={() => {
          let petPair = isPetSeatPair(seat);
          let confirmTicketData = sessionStorage.getItem('confirmTicketData');

          console.log({ petPair, seat });
          if (petPair) {
            if (confirmTicketData) return;
            if (!seat.isSelected)
              setPetseatModal({
                showModal: true,
                modalTitle: '',
                modalBody: 'Pet seat Popup',
                showButton1: true,
                buttonText1: t('RESULTS_PAGE.CONTINUE'),
              });
            props.onSeatSelect(
              CommonService.selectPetSeat(
                petPair[0],
                petPair[1],
                props.metaData,
                props.coachLayout,
                props.selectedSeatsToBook,
                props.selectedService && props.selectedService.route,
                props.isMot
              ),
            );
          } else {
            props.onSeatSelect(
              CommonService.selectSeat(
                seat,
                props.metaData,
                props.coachLayout,
                props.selectedSeatsToBook,
                props.selectedService && props.selectedService.route,
                props.isMot
              ),
            );
          }
        }}
      >
        {/* <img src={getSeatIcon(seat)}/> */}

        {getSeatIcon(seat) != 'icon-steering' ? (
          <span className="seat-number bold-text">
            {seat.number != 'DR_IMG' ? seat.number : ''}
          </span>
        ) : null}
        {getSeatIcon(seat) != 'icon-steering' ? (
          <div className={'seat-sprite ' + getSeatIcon(seat, props.petSeats)}>
            <div
              className={seat.object.available && 'seat-mousover mouseover-popups font9 nowrap'}
              key={seat.object.number}
              ref={el => {
                seatMouseoverDivEl[seat.object.number] = el;
              }}
              style={{
                marginLeft:
                  '-' +
                  (seatMouseoverDivEl[seat.object.number]
                    ? seatMouseoverDivEl[seat.object.number].clientWidth / 2
                    : 0) +
                  'px',
                pointerEvents: 'none',
              }}
            >
              {seat.object.available ? (
                <div className="mouse-over-container-inner">
                  <div>
                    {props.t('CANCEL_TICKET.SEAT_NUMBER')}: {seat.object.number}
                  </div>
                  <div>
                    {props.t('CANCEL_TICKET.FARE')}: CLP{' '}
                    {
                      CommonService.currency(seat.object.net_amount || seat.object.fare).split(
                        ',',
                      )[0]
                    }
                  </div>
                  <div>
                    {props.t('RESULTS_PAGE.SEAT_TYPE')}:{' '}
                    {CommonService.capitalize(getSeatName(seat.object.type))}
                  </div>
                  <span className="primary-triangle"></span>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </li>
    ) : null;
  };

  const onFloorChange = floor => {
    props.onFloorChange(floor);
    setTimeout(() => {
      // setState({});
    }, 250);
  };

  const getTabs = () => {
    let tabs = [];
    for (let i = 0; i < 2; i++) {
      tabs.push(
        <a
          key={i}
          className={props.selectedFloor === i ? 'active bold-text' : ''}
          // onClick={() => {onFloorChange('lower')}}
          onClick={() => {
            onFloorChange(i);
          }}
        >
          {'Piso #' + (i + 1)}
        </a>,
      );
    }
    return tabs;
  };

  let { t } = props;
  return (
    <div className="pb-service-list-coach-layout">
      <div className="flex-row floor-buttons-row ">
        <div className="font10">
          {props.upperAvalibility ? (
            <div className="floor-buttons white-text flex-row ">{getTabs()}</div>
          ) : null}
        </div>
        <div className="flex-row legends-row font10">
          <div className="flex-row legend">
            <div className="legend-color available"></div>
            <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_AVAILABLE')}</div>
          </div>
          <div className="flex-row legend">
            <div className="legend-color selected"></div>
            <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_SELECTED')}</div>
          </div>
          <div className="flex-row legend">
            <div className="legend-color reserved"></div>
            <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_OCCUPIED')}</div>
          </div>
        </div>
      </div>
      <div
        className={
          'coach-layout-container kupos-border seats-in-coach ' +
          (props.selectedFloor === 0 ? 'lower' : '')
        }
      >
        {props.selectedFloor == 0 ? (
          <div className="driver">
            <img src="/images/seats/icon-steering.png" />
            <div className="top-line"></div>
            <div className="bottom-line"></div>
          </div>
        ) : null}
        <div
          className={
            'coach-table light-text ' + (props.upperAvalibility ? '' : 'optimize-seat-spacing')
          }
        >
          {props.coachLayout ? seatRow(1) : null}
        </div>
      </div>
      <div className='red-text mt-2 mb-2 font9'>{props.motMaxSeatError && props.t('PASSENGER_DETAILS.MOT_MAX_SEATS')}</div>
      <KuposModal
        size="md"
        showModal={petseatModal.showModal}
        title={petseatModal.modalTitle}
        bodyText={petseatModal.modalBody}
        type="alert"
        showButton1={true}
        buttonText1={petseatModal.buttonText1}
        onButtonClick1={() => setPetseatModal({})}
        showButton2={false}
        buttonTextStyle={{ fontSize: 15 }}
        onHide={() => setPetseatModal({})}
        showClose={true}
      >
        <div className="pet-modal">
          <div className="pet-modal-icon">
            <img src="/svgs/pet-modal-icon.svg" />
          </div>
          <div className="pet-modal-title bold-text font15">
            <span>¡Información importante!</span>
            <div className="pet-modal-title-underline "></div>
          </div>
          <div className="pet-modal-subtitle bold-text font12">
            Seleccionaste un asiento dentro del espacio destinado a mascota a bordo.
          </div>
          <div className="pet-modal-list">
            <div className="pet-modal-list-item font11">
              <span className="pet-modal-list-dot"></span>
              <span>
                Solo pueden viajar perros y gatos en un canil que no exceda los 60 cm de largo, 34
                cm de alto y 38,5 cm de ancho.
              </span>
            </div>
            <div className="pet-modal-list-item font11">
              <span className="pet-modal-list-dot"></span>
              <span>Solo puede viajar una mascota por pasajero.</span>
            </div>
            <div className="pet-modal-list-item font11">
              <span className="pet-modal-list-dot"></span>
              <span>
                Se debe firmar una “Declaración Jurada de Tenencia Responsable” antes del viaje, la
                cual se enviará junto al pasaje.
              </span>
            </div>
          </div>
          <div className="pet-modal-button font12">
            <button className="kupos-button" onClick={() => setPetseatModal({})} type="onSubmit">
              <span>{t('HOME.OK_CONTINUE')}</span>
            </button>
          </div>
        </div>
      </KuposModal>
    </div>
  );
}

export default CoachLayout;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/CoachLayout/CoachLayout.js